import type { UseFormRegister, FieldErrors } from "react-hook-form";
import type { TFunction } from "i18next";
import { Input } from "@/shared/ui";
import type { OrganizationFormValues } from "../validation";

interface Props {
  register: UseFormRegister<OrganizationFormValues>;
  errors: FieldErrors<OrganizationFormValues>;
  t: TFunction;
  disabled: boolean;
}

export default function OrganizationBankSection({ register, errors, t, disabled }: Props) {
  return (
    <div className="p-7 radius-3xl surface-base-fill flex flex-col gap-4">
      <h2 className="text-body-bold-lg content-base-primary pb-3 border-b surface-component-stroke">
        {t("sections.bank.title")}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label={t("fields.bankName")}
          placeholder={t("placeholders.bankName")}
          disabled={disabled}
          error={errors.bank_name?.message ? t(errors.bank_name.message) : undefined}
          {...register("bank_name")}
        />
        <Input
          label={t("fields.bik")}
          placeholder={t("placeholders.bik")}
          disabled={disabled}
          error={errors.bik?.message ? t(errors.bik.message) : undefined}
          {...register("bik")}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label={t("fields.iban")}
          placeholder={t("placeholders.iban")}
          disabled={disabled}
          error={errors.iban?.message ? t(errors.iban.message) : undefined}
          {...register("iban")}
        />
      </div>
    </div>
  );
}

